<div class="container mb-pdp-tab-content mb-reviews-tab"
     data-cy="mb-reviews-tab"
     *ngIf="product$ | async as product">

  <div class="mb-pdp-tab-wrapper mb-reviews-wrapper"
       *ngIf="mbReviewData$ | async as mbReviewData">

    <div class="row no-gutters mb-3">
      <div class="col-12">
      <span class="mb-reviews-tab-headline"
            data-cy="mb-reviews-tab-headline">
        {{'mbProductTabs.reviewsFor' | mbTranslate}} <strong [innerHTML]="product.name"></strong>
      </span>
      </div>
    </div>

    <div class="row no-gutters mb-review"
         *ngFor="let review of mbReviewData.reviews | slice: 0:maxListItems, index as i"
         [attr.tabindex]="i"
         [attr.data-cy]="'mb-review-' + i">

      <div class="col-12 mb-1">
        <span class="d-inline-block pr-4 mb-review-title mb-review-comment-common-style"
              [attr.data-cy]="'mb-review-title-' + i"
              [innerHTML]="review.headline">
        </span>
        <cx-star-rating [rating]="review.rating"></cx-star-rating>
      </div>

      <div class="col-12">
        <span class="mb-review-text mb-review-comment-common-style"
              [attr.data-cy]="'mb-review-text-' + i"
              [innerHTML]="review.comment">
        </span>
      </div>

    </div>

    <div class="row no-gutters mb-reviews-actions">

      <div class="col-12 col-sm-4"
           data-cy="mb-reviews-write-a-review">
        <a class="text-decoration-none mb-reviews-actions-text"
           [href]="mbReviewData.writeReviewLink"
           target="_blank"
           data-cy="mb-write-a-review">
          {{'mbProductTabs.writeAReview' | mbTranslate}}
        </a>
      </div>

      <div class="col-12 col-sm-4 text-center">
        <div *ngIf="mbReviewData.reviews?.length > initialMaxListItems">
          <a class="text-decoration-none mb-reviews-actions-text"
             data-cy="mb-reviews-read-more"
             (click)="maxListItems = mbReviewData.reviews?.length"
             *ngIf="maxListItems === initialMaxListItems">
            {{ 'mbProductTabs.readMore' | mbTranslate }}
          </a>
          <a class="text-decoration-none mb-reviews-actions-text"
             data-cy="mb-reviews-read-less"
             (click)="maxListItems = initialMaxListItems"
             *ngIf="maxListItems !== initialMaxListItems">
            {{ 'mbProductTabs.readLess' | mbTranslate }}
          </a>
        </div>
      </div>

      <div class="col-12 col-sm-4 text-sm-right mb-reviews-logo"
           data-cy="mb-reviews-logo">
        <a class="float-sm-right"
           [href]="mbReviewData.biocompareUrl"
           target="_blank">
          <span class="d-inline-block pr-2 mb-review-comment-common-style">{{ 'mbProductTabs.poweredBy' | mbTranslate }}</span>
          <img class="d-inline-block img-responsive"
               title="Biocompare Logo"
               alt="Biocompare Logo"
               aria-label="Biocompare Logo"
               data-cy="mb-reviews-logo-image"
               [src]="mbReviewData.biocompareLogoUrl"/>
        </a>
      </div>

    </div>
  </div>

</div>
